import { useEffect, useState } from "react";

export default function Countdown({ date, compact = false }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!date) return null;
  const target = new Date(`${date}T05:00:00`).getTime();
  if (isNaN(target)) return null;
  const diff = target - now;

  if (diff <= 0) {
    return <span data-testid="countdown-raceday" className="font-mono text-xs font-semibold tracking-[0.2em] text-brand-olive">RACE DAY IS HERE</span>;
  }

  const d = Math.floor(diff / 86400000);
  const h = Math.floor(diff / 3600000) % 24;
  const m = Math.floor(diff / 60000) % 60;
  const s = Math.floor(diff / 1000) % 60;

  if (compact) {
    return (
      <span data-testid="countdown-compact" className="font-mono text-[11px] font-semibold tracking-widest text-brand-cyan">
        {d}D : {String(h).padStart(2, "0")}H : {String(m).padStart(2, "0")}M : {String(s).padStart(2, "0")}S
      </span>
    );
  }

  return (
    <div data-testid="countdown-full" className="flex gap-3">
      {[[d, "DAYS"], [h, "HRS"], [m, "MIN"], [s, "SEC"]].map(([v, label]) => (
        <div key={label} className="glass min-w-[68px] rounded-xl border border-brand-line px-3 py-2.5 text-center">
          <p className="font-display text-3xl font-bold leading-none text-white">{String(v).padStart(2, "0")}</p>
          <p className="mt-1 font-mono text-[9px] tracking-[0.25em] text-brand-olive">{label}</p>
        </div>
      ))}
    </div>
  );
}
